import React from "react";
import { motion } from "framer-motion";
import { YardSchematic } from "./YardSchematic";
import { TrainFront, Layers, AlertTriangle, ChevronRight } from "lucide-react";
import { stationName } from "../i18n";

export const StationSchematic = ({
  station,
  mode,
  lang,
  t,
  selectedWagonId,
  onWagonClick,
  onDone,
  onFocus,
  large,
  focused,
}) => {
  const name = stationName(station.code, lang);

  return (
    <motion.section
      layout
      initial={{ opacity: 0, y: 14 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.4 }}
      data-testid={`station-block-${station.code}`}
      className={`rounded-lg border bg-[#101013] ${
        station.alert ? "border-rose-600/50" : "border-zinc-800"
      } ${large ? "p-5" : "p-4"}`}
    >
      <header className="flex items-center justify-between mb-4">
        <button
          onClick={() => onFocus && onFocus(station.id)}
          data-testid={`station-focus-${station.code}`}
          className="flex items-center gap-3 group text-left"
        >
          <div
            className={`grid place-items-center rounded-md ${
              station.type === "sorting" ? "bg-sky-500/15 text-sky-400" : "bg-zinc-800 text-zinc-400"
            }`}
            style={{ width: large ? 42 : 34, height: large ? 42 : 34 }}
          >
            {station.type === "sorting" ? (
              <Layers size={large ? 22 : 18} />
            ) : (
              <TrainFront size={large ? 20 : 16} />
            )}
          </div>
          <div>
            <div className="flex items-center gap-2">
              <span
                className={`font-mono text-[10px] px-1.5 py-0.5 rounded-sm tracking-widest ${
                  station.type === "sorting"
                    ? "bg-sky-500/20 text-sky-300"
                    : "bg-zinc-800 text-zinc-400"
                }`}
              >
                {station.code}
              </span>
              <h3
                className={`font-semibold tracking-tight text-zinc-100 ${
                  large ? "text-lg" : "text-sm"
                }`}
                style={{ fontFamily: "Chivo, sans-serif" }}
              >
                {name}
              </h3>
              {!focused && (
                <ChevronRight
                  size={15}
                  className="text-zinc-600 group-hover:text-sky-400 group-hover:translate-x-0.5 transition-all"
                />
              )}
            </div>
            <span className="text-[10px] font-mono text-zinc-500 uppercase tracking-widest">
              {station.type === "sorting" ? t("sorting") : t("loading")} ·{" "}
              {station.tracks.length} {t("track").toLowerCase()} · {station.wagon_count}{" "}
              {t("wagonsOnTrack")}
            </span>
          </div>
        </button>
        {station.alert && (
          <span className="flex items-center gap-1 text-[10px] font-bold text-rose-400 bg-rose-500/15 px-2 py-1 rounded-sm tracking-widest animate-pulse">
            <AlertTriangle size={12} /> {t("overflow")}
          </span>
        )}
      </header>

      <div className="mt-1">
        <YardSchematic
          station={station}
          mode={mode}
          selectedWagonId={selectedWagonId}
          onWagonClick={onWagonClick}
          onDone={onDone}
          t={t}
          wagonSelectable={!!focused}
        />
      </div>
    </motion.section>
  );
};
